import urls from '@constants/urls';
import { isFeatureEnabled } from '@utils/featureFlags';
import { AppTypes } from '@ts/common.types';
import { isStandaloneMode } from '@constants/app-modes';

declare const IS_DEV: boolean;
declare const REALM: string;

export type PageLinkType = {
  path: string;
  icon: string;
  name: string;
  activePrefix?: string;
  isShown?: () => boolean;
  beta?: boolean;
};

export const pagesLinks = (workspaceId: number): PageLinkType[] => {
  switch (REALM) {
    case AppTypes.concierge:
      return [
        {
          path: urls.ORDERS(workspaceId),
          name: 'Orders',
          icon: 'bucketLink',
          activePrefix: `/workspaces/\\d+/orders`,
        },
        {
          path: urls.PLACEMENTS(workspaceId),
          name: 'Placements',
          icon: 'squareLink',
          activePrefix: `/workspaces/\\d+/placements`,
        },
        {
          path: urls.ORDER_CAMPAIGNS(workspaceId),
          name: 'Campaigns',
          icon: 'campaigns',
          activePrefix: `/workspaces/\\d+/campaigns`,
        },
      ];
    case AppTypes.publisher:
      return [
        {
          path: urls.ORDERS(workspaceId),
          name: 'Orders',
          icon: 'bucketWithArrow',
          activePrefix: `/workspaces/\\d+/orders`,
        },
        {
          path: urls.WEBSITES(workspaceId),
          name: 'Websites',
          icon: 'widget',
          activePrefix: `/workspaces/\\d+/websites`,
        },
      ];
    case AppTypes.app:
    default:
      return [
        ...(isStandaloneMode()
          ? [
              {
                path: urls.DASHBOARD,
                name: 'Dashboard',
                icon: 'dashboard',
                activePrefix: '/dashboard',
              },
            ]
          : []),
        {
          path: urls.ALL_CAMPAIGNS(workspaceId),
          name: 'Campaigns',
          icon: 'campaigns',
          activePrefix: `/workspaces/\\d+/campaigns`,
        },
        {
          path: `/workspaces/${workspaceId}/relationships/websites`,
          name: 'Relationships',
          icon: 'relationships',
          activePrefix: '/workspaces/\\d+/relationships',
        },
        {
          path: `/workspaces/${workspaceId}/insights/campaign-reports`,
          name: 'Insights',
          icon: 'insights',
          activePrefix: '/workspaces/\\d+/insights',
        },
        {
          path: `/workspaces/${workspaceId}/inbox/all`,
          name: 'Inbox',
          icon: 'inbox',
          activePrefix: '/workspaces/\\d+/inbox',
        },
        ...(isFeatureEnabled('ENABLE_PRESS_INQUIRIES', { includeDev: false })
          ? [
              {
                path: '/inquiries/all-inquiries',
                name: 'Press Inquiries',
                icon: 'inquiries',
                activePrefix: '/inquiries',
              },
            ]
          : []),
        {
          path: '/toolbox/email-finder',
          name: 'Toolbox',
          icon: 'toolbox',
          activePrefix: '/toolbox',
        },
        ...(isStandaloneMode() && IS_DEV
          ? [
              {
                path: urls.AI_AGENTS(workspaceId),
                name: 'AI Agents',
                icon: 'aiStar',
                activePrefix: `/workspaces/\\d+/ai-agents`,
              },
            ]
          : []),
      ];
  }
};
